import { z } from 'zod';
import {
  SoftwareObservationSourceTypeSchema,
  SoftwareOwnershipSchema,
  SoftwareTypeSchema,
} from '@terra/shared-schemas-orchestrator';

export const UpsertSoftwareObservationSchema = z.object({
  sourceType: SoftwareObservationSourceTypeSchema,
  text: z.string().min(1),
});

export const UpdateSoftwareSchema = z.object({
  networkServiceId: z.string().min(1),
  softwareType: SoftwareTypeSchema,
  product: z.string().min(1),
  vendor: z.string().optional(),
  version: z.string().optional(),
  domainName: z.string().optional(),
  ownership: SoftwareOwnershipSchema.optional(),
  observation: UpsertSoftwareObservationSchema.optional(),
});

export const UpdateSoftwareResponseSchema = z.object({
  message: z.string(),
});
